import { memo, ReactElement } from 'react'

import cn from 'classnames'

import c from './Label.module.scss'

interface ILabel {
  text: string | ReactElement
  children: ReactElement
  className?: string
}

export const Label = memo(({ text = '', children, className = '' }: ILabel) => {
  return (
    <label className={`${cn(className, c.label)}`}>
      <div className={c.labelText}>{text}</div>
      {children}
    </label>
  )
})
